import React from 'react'
import FeedItem from '../Global/FeedItem'
import { Link } from 'react-router-dom'
/* REDUX */
import { connect } from 'react-redux'
import { loadReports } from '../../actions/reports'
import { formatHeading } from '../../utility/Formatter'

const loadData = ({ category, loadReports }) => {
	loadReports(category)
}

class Feed extends React.Component {
	
	componentWillMount() {
		loadData(this.props)
	}

	render() {
		
		const { category, reports } = this.props

		if (!reports) {
			return <div></div>
		}
		
		const reportsList = reports.map((report, key) => {
			if (key < 5) {
				return <FeedItem key={ report._id } {...report} onLogin={ this.props.onLogin } />
			}
		})
		
		let formattedHeading = formatHeading(category)
				
		return (
			<div className="feed">
				<ul>
					<li>
						<div className="stack">
							<h2 className="heading">{ formattedHeading }</h2>
						</div>
					</li>
					{ reportsList }
					<li>
						<Link to={"/category/" + category}>
							<div className="stack fin">
								<span className="text">View More</span>
							</div>
						</Link>
					</li>
				</ul>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const category = ownProps.feed
	const {
		reportsByCategory
	} = state
	const reportsWrapper = reportsByCategory[category] || {}
	const reports = reportsWrapper.reports
	return {
		category,
		reports
	}
}

export default connect(mapStateToProps, { loadReports })(Feed)


// WEBPACK FOOTER //
// ./src/components/Home/Feed.js